import cn from "classnames";
import {ComponentClassName} from "@dp-instant/ui";
import "./ExclamationMarkNotificator.less";

export const ExclamationMarkNotificator = ({className = ""}: ComponentClassName) => (
    <div className={cn("exclamation-mark-notificator", className)}></div>
);
